import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { SectionProps } from './SectionProps';
import { SocItemDetailsAo } from '../../domain/SocItemDetailsAo';
import { KloeFileUpload } from './KloeFileUpload';

export const Kloe2AOSection: React.FC<SectionProps<SocItemDetailsAo>> = (
  sectionProps,
) => {
  return (
    <Grid container spacing={3}>
      <Typography variant="h6"></Typography>
      <KloeFileUpload sectionProps={sectionProps} kloeType="KLOE2" />
    </Grid>
  );
};
